import './App.css';
import HomePage from './components/HomePage';
import NavBarMain from './components/NavBarMain';
import RouterMain from './components/RouterMain';
import VolunteerList from './components/VolunteerList';

function App() {
  return (
    <div className="min-h-screen bg-base-200 text-base-content">
      <div className="min-h-screen">
        {/* <NavBarMain/> */}
        <RouterMain />
      </div>
    </div>
  );
}

export default App;
